import React, {
  useCallback,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";
import {
  DropZone,
  Page,
  FormLayout,
  TextField,
  Card,
  PageActions,
  Toast,
  Button,
  Text,
  Loading,
  Checkbox,
  Select,
  InlineStack,
  Thumbnail,
  Layout,
  List,
  Modal,
  BlockStack,
  InlineGrid,
  ButtonGroup,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { NoteMinor, LanguageIcon } from "@shopify/polaris-icons";
import { Editor } from "@tinymce/tinymce-react";
import { ChannelsModal } from "./Modals/ChannelsModal";
import { accessDeleteBlogs, accessDeletePages } from "../../Helpers";
import axiosDefault from "axios";
import LoadingScreen from "../../Components/LoadingScreen";
import TagsInput from "react-tagsinput";
import { Switch } from "@material-ui/core";
import FormControlLabel from "@mui/material/FormControlLabel";
import JoditEditor from "jodit-react";

const EditPage = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isSaving, setIsSaving] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [optionsLanguages, setOptionsLanguages] = useState("");

  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeDescription = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, description: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeInstruction = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, instruction: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeTagsKeywords = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, tags: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeAlias = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, alias: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSeoTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, seoTitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSeoDescription = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, seoDescription: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeDescriptionTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, description: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeAliasTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, alias: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSeoTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, seoTitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSeoDescriptionTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, seoDescription: value };
      }
      return obj;
    });
    setData(newState);
  };
  const [selected, setSelected] = useState(["hidden"]);
  const handleChoiceListChange = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: value };
      }
      return obj;
    });
    setData(newState);
  };
  const [activeChannels, setActiveChannels] = useState(false);
  const handleChangeActiveChannels = useCallback(
    () => setActiveChannels(!activeChannels),
    [activeChannels]
  );
  const handleChangeActiveChannelsDone = () => {
    setActiveChannels(false);
    setChannelsToShow(selectedChannels);
  };
  const [channels, setChannels] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [channelsToShow, setChannelsToShow] = useState([]);
  const handleSelectedChannels = (param) => {
    setSelectedChannels(param);
  };
  const [isAutomaticExport, setIsAutomaticExport] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseLanguages = "";
    let responseChannels = "";
    try {
      responseLanguages = await axios.get(
        `/settings/languages?filter[is_active]=1`
      );
      responseLanguages?.data?.data?.data &&
        setOptionsLanguages(
          responseLanguages.data.data.data.map((item, index) => {
            return {
              label: item.name,
              value: item.code,
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseChannels = await axios.get(`/channels`);
      responseChannels?.data?.data?.data &&
        setChannels(
          responseChannels.data.data.data.map((item, index) => {
            return {
              label: item.name,
              value: item.id,
              id: item.id,
            };
          })
        );
    } catch (error) {
      console.log(error);
    }

    try {
      const responseItem = await axios.get(`/pages/${id}`);
      const object = responseItem.data.data;
      responseLanguages?.data?.data?.data &&
        setData(
          responseLanguages?.data?.data?.data
            .concat([{ label: "English", code: "en" }])
            .map((element, index) => {
              return {
                language: element.code,
                active: object?.is_active ? true : false,
                instruction: object?.instructions ? object?.instructions : "",
                title:
                  object?.title && object?.title[element.code]
                    ? object?.title[element.code]
                    : "",
                description:
                  object?.description && object?.description[element.code]
                    ? object?.description[element.code]
                    : "",
                alias: object?.alias ? object?.alias : "",
                seoTitle:
                  object?.seo_title && object?.seo_title[element.code]
                    ? object?.seo_title[element.code]
                    : "",
                seoDescription:
                  object?.seo_description &&
                  object?.seo_description[element.code]
                    ? object?.seo_description[element.code]
                    : "",
                seoImage:
                  object?.seo_image && object?.seo_image[element.code]
                    ? object?.seo_image[element.code]
                    : "",
                fileImage: "",
                tags: object?.tags,
              };
            })
        );

      setDateValue(responseItem?.data?.data?.date ?? "");
      setIsAutomaticExport(
        responseItem?.data?.data?.is_auto_export ? true : false
      );
      responseItem?.data?.data?.channels &&
        setChannelsToShow(
          responseItem?.data?.data?.channels.map((item) => item.id)
        );
      setSelectedChannels(
        responseItem?.data?.data?.channels.map((item) => item.id)
      );
      // responseItem?.data?.data && setResult(responseItem?.data?.data);
      // responseItem?.data?.data &&
      //   setItem({
      //     title: responseItem?.data?.data?.title["en"]
      //       ? responseItem?.data?.data?.title["en"]
      //       : "",
      //     alias: responseItem?.data?.data?.alias
      //       ? responseItem?.data?.data?.alias
      //       : "",
      //     seoTitle: responseItem?.data?.data?.seo_title["en"]
      //       ? responseItem?.data?.data?.seo_title["en"]
      //       : "",
      //     seoDescription: responseItem?.data?.data?.seo_description["en"]
      //       ? responseItem?.data?.data?.seo_description["en"]
      //       : "",
      //     active: responseItem?.data?.data?.is_active ? "visible" : "hidden",
      //   });
    } catch (error) {
      console.log(error);
    }
    setIsSaving(false);
  }
  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, jsons and webp"}
    />
  );
  const uploadedFile = file && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* Uncomment if using thumbnail */}
      {/*
    <Thumbnail
      size="small"
      alt={file.name}
      source={
        validImageTypes.includes(file.type)
          ? window.URL.createObjectURL(file)
          : NoteMinor
      }
    />
    */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </InlineStack>
  );
  const [image, setImage] = useState("");

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "page");
    form_data.append("seo_image[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              fileImage: imageKey.current,
              seoImage:
                validImageTypes.indexOf(file[file.length - 1].type) > 0
                  ? window.URL.createObjectURL(file[file.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileTranslated, setFileTranslated] = useState();
  const handleDropZoneDropTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslated((fileTranslated) => acceptedFiles[0]),
    []
  );
  const fileUploadTranslated = !fileTranslated && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, jsons and webp"}
    />
  );
  const uploadedFileTranslated = fileTranslated && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* Uncomment if using thumbnail */}
      {/*
    <Thumbnail
      size="small"
      alt={fileTranslated.name}
      source={
        validImageTypes.includes(fileTranslated.type)
          ? window.URL.createObjectURL(fileTranslated)
          : NoteMinor
      }
    />
    */}
      <div>
        {fileTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslated.size} bytes
        </Text>
      </div>
    </InlineStack>
  );

  const imageKeyTranslated = useRef("");
  const sendImageTranslated = (fileTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "page");
    form_data.append(
      `seo_image[${selectedLanguage}]`,
      fileTranslated[fileTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyTranslated.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              fileImage: imageKeyTranslated.current,
              seoImage:
                validImageTypes.indexOf(
                  fileTranslated[fileTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslated[fileTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };
  const options = [
    "bold",
    "italic",
    "|",
    "ul",
    "ol",
    "|",
    "font",
    "fontsize",
    "|",
    "outdent",
    "indent",
    "align",
    "|",
    "hr",
    "|",
    "fullsize",
    "brush",
    "|",
    "table",
    "link",
    "|",
    "undo",
    "redo",
    // {
    //   icon: "image",
    //   name: "imagePicker",
    //   exec: handleImageButtonClick,
    //   tooltip: "Insert Image",
    // },
    // "image",
  ];
  const editorRef = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      defaultActionOnPaste: "insert_as_html",
      defaultLineHeight: 1.5,
      enter: "div",
      // options that we defined in above step.
      buttons: options,
      buttonsMD: options,
      buttonsSM: options,
      buttonsXS: options,
      statusbar: false,
      sizeLG: 900,
      sizeMD: 700,
      sizeSM: 400,
      toolbarAdaptive: false,
      toolbar: true,
    }),
    []
  );
  const [suggestions, setSuggestions] = useState([]);
  const [query, setQuery] = useState("");
  const [input, setInput] = useState("");

  useEffect(() => {
    if (query.length >= 1) {
      axios
        .get(
          `/search/${
            props.type === "blogs" ? "blog" : "page"
          }/tags?query=${query}`
        )
        .then((res) => setSuggestions(res.data.data)) // Adjust API response format
        .catch((err) => console.error(err));
    } else {
      //setSuggestions([]);
    }
  }, [query]);
  const inputRef = useRef(null);
  const handleTyping = (newInput) => {
    setInput(newInput);
    setQuery(newInput);
  };
  const [dateValue, setDateValue] = useState("");
  const handleChangeDate = (newValue) => {
    setDateValue(newValue);
  };

  return (
    <Page
      title={props.title}
      backAction={{ onAction: () => navigate(`/admin/${props.type}`) }}
    >
      {isSaving ? <Loading /> : null}

      <FormLayout>
        <Card roundedAbove="sm">
          <BlockStack gap="200">
            <InlineGrid columns="1fr auto">
              <Text as="h2" variant="headingSm"></Text>
              <Button
                variant="plain"
                onClick={handleTranslate}
                accessibilityLabel="Preview"
              >
                {translatedButtonClicked ? "Edit English" : "Translate"}
              </Button>
            </InlineGrid>

            <FormLayout>
              <table>
                <tbody>
                  <tr>
                    <th>
                      <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
                    </th>
                    <th>
                      <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
                    </th>
                    {translatedButtonClicked && (
                      <th>
                        <Select
                          options={optionsLanguages}
                          onChange={handleSelectChangeLanguage}
                          value={selectedLanguage}
                          placeholder="Please select a language"
                        />
                      </th>
                    )}
                  </tr>
                  <tr>
                    <td>
                      <Text variant="bodyMd" as="p" color="subdued">
                        Title
                      </Text>
                    </td>
                    <td>
                      <TextField
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").title
                        }
                        onChange={handleChangeTitle}
                        disabled={translatedButtonClicked}
                      />
                    </td>
                    {translatedButtonClicked && (
                      <td>
                        <TextField
                          value={
                            findArrayElementByLanguage(
                              data,
                              selectedLanguage
                            ) &&
                            findArrayElementByLanguage(data, selectedLanguage)
                              .title
                          }
                          onChange={handleChangeTitleTranslated}
                        />
                      </td>
                    )}
                  </tr>

                  <tr>
                    <td>
                      <Text variant="bodyMd" as="p" color="subdued">
                        Description
                      </Text>
                    </td>
                    <td>
                      <TextField
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").description
                        }
                        onChange={handleChangeDescription}
                        disabled={translatedButtonClicked}
                      />
                    </td>
                    {translatedButtonClicked && (
                      <td>
                        <TextField
                          value={
                            findArrayElementByLanguage(
                              data,
                              selectedLanguage
                            ) &&
                            findArrayElementByLanguage(data, selectedLanguage)
                              .description
                          }
                          onChange={handleChangeDescriptionTranslated}
                        />
                      </td>
                    )}
                  </tr>

                  <tr>
                    <td>
                      <Text variant="bodyMd" as="p" color="subdued">
                        Alias
                      </Text>
                    </td>
                    <td>
                      <TextField
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").alias
                        }
                        onChange={handleChangeAlias}
                        // disabled
                      />
                    </td>
                    {/* {translatedButtonClicked && (
                    <td>
                      <TextField
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").alias
                        }
                        onChange={handleChangeAliasTranslated}
                        disabled
                      />
                    </td>
                  )} */}
                  </tr>
                  <tr>
                    <td>
                      <Text variant="bodyMd" as="p" color="subdued">
                        SEO Title
                      </Text>
                    </td>
                    <td>
                      <TextField
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").seoTitle
                        }
                        onChange={handleChangeSeoTitle}
                        disabled={translatedButtonClicked}
                      />
                    </td>
                    {translatedButtonClicked && (
                      <td>
                        <TextField
                          value={
                            findArrayElementByLanguage(
                              data,
                              selectedLanguage
                            ) &&
                            findArrayElementByLanguage(data, selectedLanguage)
                              .seoTitle
                          }
                          onChange={handleChangeSeoTitleTranslated}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td>
                      <Text variant="bodyMd" as="p" color="subdued">
                        SEO Description
                      </Text>
                    </td>
                    <td>
                      <TextField
                        value={
                          findArrayElementByLanguage(data, "en") &&
                          findArrayElementByLanguage(data, "en").seoDescription
                        }
                        onChange={handleChangeSeoDescription}
                        disabled={translatedButtonClicked}
                      />
                    </td>
                    {translatedButtonClicked && (
                      <td>
                        <TextField
                          value={
                            findArrayElementByLanguage(
                              data,
                              selectedLanguage
                            ) &&
                            findArrayElementByLanguage(data, selectedLanguage)
                              .seoDescription
                          }
                          onChange={handleChangeSeoDescriptionTranslated}
                        />
                      </td>
                    )}
                  </tr>

                  <tr>
                    <td>
                      <Text variant="bodyMd" as="p" color="subdued">
                        SEO Image
                      </Text>
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div style={{ float: "left" }}>
                          <Thumbnail
                            size="large"
                            source={
                              findArrayElementByLanguage(data, "en") &&
                              findArrayElementByLanguage(data, "en").seoImage
                                ? findArrayElementByLanguage(data, "en")
                                    .seoImage
                                : ""
                            }
                          />
                        </div>
                        <div
                          style={{
                            width: "100%",
                            marginLeft: "10px",
                          }}
                        >
                          <DropZone
                            accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                            //   type="file"
                            allowMultiple={false}
                            onDrop={handleDropZoneDrop}
                            onDropAccepted={sendImage}
                          >
                            {uploadedFile}
                            {fileUpload}
                          </DropZone>
                        </div>
                      </div>
                    </td>
                    {translatedButtonClicked && (
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                          }}
                        >
                          <div style={{ float: "left" }}>
                            <Thumbnail
                              size="large"
                              source={
                                findArrayElementByLanguage(
                                  data,
                                  selectedLanguage
                                ) &&
                                findArrayElementByLanguage(
                                  data,
                                  selectedLanguage
                                ).seoImage
                                  ? findArrayElementByLanguage(
                                      data,
                                      selectedLanguage
                                    ).seoImage
                                  : ""
                              }
                            />
                          </div>
                          <div
                            style={{
                              width: "100%",
                              marginLeft: "10px",
                            }}
                          >
                            <DropZone
                              accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                              //   type="file"
                              allowMultiple={false}
                              onDrop={handleDropZoneDropTranslated}
                              onDropAccepted={sendImageTranslated}
                            >
                              {uploadedFileTranslated}
                              {fileUploadTranslated}
                            </DropZone>
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
              <FormLayout>
                <Text>Tags</Text>
                <TagsInput
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").tags &&
                    findArrayElementByLanguage(data, "en").tags.length
                      ? findArrayElementByLanguage(data, "en").tags
                      : []
                  }
                  inputValue={input}
                  onChangeInput={handleTyping}
                  inputRef={inputRef}
                  onChange={handleChangeTagsKeywords}
                />

                {suggestions.length > 0 && (
                  <ul
                    style={{
                      position: "absolute",
                      background: "#e9e9e9",
                      color: "black",
                      border: "1px solid #ddd",
                      listStyle: "none",
                      padding: "5px",
                      width: "200px",
                      zIndex: 1000,
                    }}
                  >
                    {suggestions.map((suggestion) => (
                      <li
                        key={suggestion}
                        style={{ cursor: "pointer", padding: "5px" }}
                        onClick={() => {
                          const newState = data.map((obj) => {
                            if (obj.language === "en") {
                              return {
                                ...obj,
                                tags: [...(obj.tags || []), suggestion],
                              };
                            }
                            return obj;
                          });
                          setData(newState);
                          setSuggestions([]);
                          setInput("");
                        }}
                      >
                        {suggestion}
                      </li>
                    ))}
                  </ul>
                )}

                {props?.type === "blogs" ? (
                  <TextField
                    label="Date"
                    value={dateValue}
                    onChange={handleChangeDate}
                    type="date"
                  />
                ) : null}

                <Text variant="bodyMd" as="p" fontWeight="regular">
                  Instruction
                </Text>
                <JoditEditor
                  ref={editorRef}
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").instruction
                  }
                  config={config}
                  onChange={handleChangeInstruction}
                />
              </FormLayout>
            </FormLayout>
          </BlockStack>
        </Card>

        <Card sectioned title="Automatic Export">
          <FormLayout>
            <FormControlLabel
              control={
                <Switch
                  checked={isAutomaticExport}
                  onChange={() => {
                    setIsAutomaticExport(!isAutomaticExport);
                    const bodyObj = {
                      is_auto_export: !isAutomaticExport === true ? 1 : 0,
                      page_handle:
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").alias,
                    };

                    axios
                      .post(`/page-sections/toggle-export`, bodyObj)
                      .then((result) => {})
                      .catch(function (error) {});
                  }}
                />
              }
              label="Automatic Export"
              labelPlacement="end"
            />
          </FormLayout>
        </Card>

        <Card>
          <FormLayout>
            <Text as="p" fontWeight="bold">
              Visibility
            </Text>
            <Checkbox
              label="Is Visible"
              checked={
                findArrayElementByLanguage(data, "en") &&
                findArrayElementByLanguage(data, "en").active
              }
              onChange={handleChange}
            />
          </FormLayout>
        </Card>
        <Card
          actions={[
            {
              content: "Manage",
              onAction: () => setActiveChannels(true),
            },
          ]}
        >
          <FormLayout>
            <Text as="p" fontWeight="bold">
              Channels
            </Text>
            {channelsToShow && channelsToShow.length ? (
              <List type="bullet">
                {channelsToShow.map((element, index) => {
                  return (
                    <List.Item key={index}>
                      {findElementByID(channels, element) &&
                        findElementByID(channels, element).label &&
                        findElementByID(channels, element).label}
                    </List.Item>
                  );
                })}
              </List>
            ) : (
              <Text>No channels</Text>
            )}
          </FormLayout>
        </Card>
      </FormLayout>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={[
          {
            content: "Delete",
            destructive: true,
            loading: isSaving,
            disabled:
              ((props.type === "pages" && !accessDeletePages()) ||
                (props.type === "blogs" && !accessDeleteBlogs())) &&
              true,
            onClick: () => {
              setIsSaving(true);
              axios
                .delete(`/${props.type}/${id}`)
                .then((result) => {
                  navigate(`/admin/${props.type}`);
                })
                .catch((err) => console.log(err));
            },
          },
        ]}
      />
      <Modal
        open={activeChannels}
        onClose={handleChangeActiveChannels}
        title="Manage Channels"
        primaryAction={{
          content: "Done",
          onAction: handleChangeActiveChannelsDone,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChangeActiveChannels,
          },
        ]}
      >
        <Modal.Section>
          <ChannelsModal
            channels={channels}
            handleSelectedChannels={handleSelectedChannels}
            selectedChannels={selectedChannels}
          />
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );
  function handleSave() {
    setIsSaving(true);
    const form_data = new FormData();
    data.forEach((selected, index) =>
      form_data.append(`title[${selected.language}]`, selected.title)
    );
    data.forEach((selected, index) =>
      form_data.append(
        `description[${selected.language}]`,
        selected.description
      )
    );
    data.forEach((selected, index) =>
      form_data.append(`seo_title[${selected.language}]`, selected.seoTitle)
    );
    data.forEach((selected, index) =>
      form_data.append(
        `seo_description[${selected.language}]`,
        selected.seoDescription
      )
    );
    data[data.length - 1].alias &&
      form_data.append("alias", data[data.length - 1].alias);
    data.forEach((selected, index) =>
      form_data.append(`seo_image[${selected.language}]`, selected.fileImage)
    );
    form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
    form_data.append("_method", "PATCH");
    form_data.append("date", dateValue);
    findArrayElementByLanguage(data, "en").instruction &&
      form_data.append(
        "instructions",
        findArrayElementByLanguage(data, "en").instruction
      );

    selectedChannels && selectedChannels.length
      ? selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    findArrayElementByLanguage(data, "en").tags?.length &&
      findArrayElementByLanguage(data, "en").tags.forEach((selected, index) =>
        form_data.append(`tags[${index}]`, selected)
      );
    axios
      .post(`/${props.type}/${id}`, form_data)
      .then((res) => {
        setIsSaving(false);
        setToastContent("Changes have been saved succesffully");
        toggleActiveToast();
      })
      .catch(function (error) {
        if (error.response) {
          setToastContent(error.response.data.message);
          toggleActiveToast();
          setIsSaving(false);
        }
      });
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};
export default EditPage;
